import { z } from 'zod';
import { looksLikeCardNumber } from '../utils/looksLikeCardNumber';

export const CASE_REFERENCE_MAX_LENGTH = 100;
export const REASON_MAX_LENGTH = 500;

export const accessJustificationSchema = z.object({
    caseReference: z
        .string()
        .trim()
        .max(CASE_REFERENCE_MAX_LENGTH, `The case number cannot exceed ${CASE_REFERENCE_MAX_LENGTH} characters`)
        .refine((value) => !looksLikeCardNumber(value), 'The case number must not contain a card number'),
    reason: z
        .string()
        .trim()
        .max(REASON_MAX_LENGTH, `The reason cannot exceed ${REASON_MAX_LENGTH} characters`)
        .refine((value) => !looksLikeCardNumber(value), 'The reason must not contain a card number'),
});

export type AccessJustificationFormInput = z.input<typeof accessJustificationSchema>;
export type AccessJustificationFormValues = z.output<typeof accessJustificationSchema>;
